import { useEffect, useState } from "react";

import FormModal from "../../widgets/FormModal";
import { Link } from "react-router-dom";
import Header from "../../widgets/Header";
import Footer from "../../widgets/Footer";


function StudyReveals() {

    const [show, setShow] = useState(false);
      const openIframeWindow = () => {
        setShow(!show);
      }
    return (
        <> <section className="light_bg">
            <Header />
            <div className="top_space"></div>
           
            <section className="ps">
                <div className="container">
                    <h1 className="hadding">Study Reveals 99.6% of Individuals with Low Stress Resilience Genes Have a High Genetic Risk for Depression</h1>
                 
                    <div className="position-relative  mt-4 mb-4">
                        <img src="/assets/img/research/study-reveals.webp" alt="Study Reveals" className="w100 br20"/>
                    </div>
                  <h3 className="op0_8"> Overview</h3>
                    <p> A new genetic analysis conducted by Dr. Sajeev Nair, Reshma K.R., and team examined 500 EPLIMO genetic predisposition reports and uncovered a striking finding: 99.6% of individuals carrying gene variants linked to low stress resilience also showed a high genetic predisposition to depression.
This research highlights how understanding one’s genetic makeup can play a transformative role in mental health prevention and management, emphasizing the power of personalized wellness through EPLIMO. </p>
                   
                     <h3 className="op0_8"> Understanding the Connection</h3>
                    
                    <p> 
Stress resilience is the body’s ability to adapt to and recover from challenges. When this resilience is genetically lower, the risk of developing depression increases significantly.
The study found that genetics, not just environment, plays a major role in determining how effectively a person copes with stress. This reinforces the importance of early identification and intervention for those at risk.</p>

 <h3 className="op0_8"> Inside the Genetic Study</h3>
 Study Design:
                    <ul class="mb-4 dot_list">
                        <li>Sample Size: 500 EPLIMO genetic predisposition test reports </li>
                        <li>Focus: Individuals carrying gene variants linked to low stress resilience </li>
                        <li> Analysis: Correlation between genetic markers for low stress resilience and depression risk</li>
                       
                    </ul>
          Key Results:
              <ul class="mb-4 dot_list">
                        <li>Out of 500 individuals, 498 (99.6%) carried gene variants associated with a high risk for depression.</li>
                    </ul>
 
                    <p> This demonstrates a direct and overwhelming genetic link between stress resilience and depression susceptibility. </p>
               


                      <h3 className="op0_8">Why This Matters

 </h3>
                    <p> The findings confirm that genetics can strongly influence how individuals experience and recover from stress. Those with low stress resilience genes are far more likely to develop depression if not supported by preventive interventions.
This underlines the need for early genetic screening and personalized lifestyle strategies that can improve resilience and protect mental well-being. </p>


      <h3 className="op0_8">The Role of EPLIMO
 </h3>
                    <p> 
EPLIMO (Epigenetic Lifestyle Modification) is an advanced genetic and lifestyle testing platform that analyzes over 275 health-related genetic markers. It provides insights into physical, metabolic, and psychological traits, allowing experts to design personalized wellness plans.



 </p>
                 For individuals with genetic markers linked to low stress resilience, EPLIMO offers:    
                    <ul class="mb-4 dot_list">
               <li>Tailored nutrition and supplementation plans</li>
               <li>Personalized exercise and stress management techniques </li>
            <li>Early preventive guidance for emotional well-being </li>
                    </ul>
<p>This approach ensures scientifically precise and sustainable interventions instead of generic wellness recommendations</p>


                      <h3 className="op0_8">Key Takeaways </h3>
        
                    <ul class="mb-4 dot_list">
                        <li>99.6% correlation between low stress resilience genes and depression risk </li>
                        <li>Highlights genetics as a foundational factor in mental health </li>
                        <li>Demonstrates how personalized wellness strategies can prevent mental health issues before they appear </li>
                        <li>Supports the use of EPLIMO for identifying and addressing mental health risks early </li>
                    </ul> 

                   <h3 className="op0_8">Conclusion </h3>
                    <p> Genetic predisposition to low stress resilience is strongly associated with a higher risk of depression. </p>
                    <p> This study emphasizes the importance of personalized interventions guided by genetic insights to enhance resilience, prevent depression, and improve overall mental well-being.
 </p>
                     <h3 className="op0_8">References </h3>Adapted from:
                    <ul class="mb-4 dot_list">
                        <li>
“Study Reveals That 99.6% of Individuals Carrying Gene Variants for Low Stress Resilience Have High Risk for Depression”
By Dr. Sajeev Nair, Reshma K.R., et al.
 <br/>
 <br/>
 Cited works include peer-reviewed studies from Nature Reviews Neuroscience, Frontiers in Psychiatry, and the American Journal of Medical Genetics. </li>
                    </ul> 

                    <div className="pt-4 text-center">
                        <a href="genetic-link" className="back_btn bn_btn"><i className="bi bi-chevron-left"></i></a>
                        <a href="genetic-risk" className="next_btn bn_btn"><i className="bi bi-chevron-right"></i></a>
                    </div>


                </div>

            </section>


            <section className="you_ready_sec text-white position-relative  overflow-hidden">
                <img src="/assets/img/research/research_r_bg.webp" alt="cour raddy" className="cour_raddy mo_none" />
                <img src="/assets/img/research/research_r_bg2.webp" alt="cour raddy" className="cour_raddy pc_none" />

                <div className="container position-relative">
                    <div className="row position-relative">
                        <div className="col-md-5  ms-auto">
                            <h2 className="hadding mb-4    ">Are You Ready to Take Control of Your Future Health?</h2>
                            <p className=" mb-md-4 mb-3 ">EPLIMO is more than a health check. It’s a blueprint for living stronger,
                                longer, and happier. Don’t wait for symptoms to become problems. Take charge today and start
                                living at your peak.</p>
                            <a className="btn" onClick={() => openIframeWindow()}>Join EPLIMO<sup className="sup-font">TM</sup> Program</a>
                        </div> 
                    </div>
                     <FormModal show={show} setShow={setShow} />
                </div>
            </section>
             
            <Footer /> </section>
        </>
    );
}

export default StudyReveals;
